import type { NoteColor } from "@sebas/core";
import { Pin } from "lucide-react";
import { cn } from "@/lib/cn";

/** Tile backgrounds stay saturated in both themes; their ink is always dark. */
const TILE_BG: Record<NoteColor, string> = {
  sand: "bg-tile-sand",
  coral: "bg-tile-coral",
  amber: "bg-tile-amber",
  mint: "bg-tile-mint",
  sky: "bg-tile-sky",
  lilac: "bg-tile-lilac",
};

export function NoteTile({
  title,
  meta,
  icon,
  color = "sand",
  pinned = false,
  className,
  children,
}: {
  title: string;
  meta?: string;
  /** Template mark, shown for notes that are more than free text. */
  icon?: React.ReactNode;
  color?: NoteColor;
  pinned?: boolean;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <article
      className={cn(
        "flex h-full flex-col gap-3 rounded-tile p-5 text-tile-ink",
        "transition-transform duration-200 hover:-translate-y-0.5",
        TILE_BG[color],
        className,
      )}
    >
      <header>
        <h3 className="font-display flex items-start gap-2 text-xl font-semibold leading-tight">
          {icon ? <span className="mt-0.5 shrink-0 opacity-70">{icon}</span> : null}
          <span className="flex-1">{title}</span>
          {pinned ? <Pin className="mt-1 h-4 w-4 shrink-0 fill-current" /> : null}
        </h3>
        {meta ? <p className="mt-1 text-xs text-tile-ink/60">{meta}</p> : null}
      </header>
      {children}
    </article>
  );
}
